import * as React from 'react'
import type {ResponsiveImageData} from '../../types/responsiveImage'

export interface ResponsiveImageProps {
  data: ResponsiveImageData
  className?: string
  fetchpriority?: 'high' | 'low' | 'auto'
  loading?: 'lazy' | 'eager'
}

export const ResponsiveImage = ({
  data,
  className = '',
  fetchpriority,
  loading,
}: ResponsiveImageProps) => {
  const isHighPriority = fetchpriority === 'high'
  const resolvedLoading = loading ?? (isHighPriority ? 'eager' : 'lazy')
  const decoding = isHighPriority ? 'sync' : 'async'

  return (
    <img
      src={data.src}
      srcSet={data.srcset}
      sizes={data.sizes}
      alt={data.alt}
      aria-hidden={data.ariaHidden || undefined}
      width={data.width}
      height={data.height}
      loading={resolvedLoading}
      decoding={decoding}
      fetchPriority={fetchpriority}
      className={className}
      style={{
        aspectRatio: `${data.width} / ${data.height}`,
        background: `url(${data.lqipUrl}) center / cover no-repeat`,
        objectPosition: data.focalPoint
          ? `${data.focalPoint.x * 100}% ${data.focalPoint.y * 100}%`
          : undefined,
      }}
      onLoad={(e) => {
        ;(e.target as HTMLImageElement).style.background = 'none'
      }}
    />
  )
}
